import RiquetSection from "@/components/home/RiquetSection";
import EditorialMarquee from "@/components/home/EditorialMarquee";
import UnescoMarquee from "@/components/UnescoMarquee";

export default function RiquetPage() {
  return (
    <main className="pt-24" data-testid="riquet-page">
      <UnescoMarquee />
      <RiquetSection />
      <EditorialMarquee inverted />
    </main>
  );
}
